export function cohortScopeKey(programId: string, cohortId: string): string {
  return `${programId}:${cohortId}`;
}

export function parseCohortScopeKey(
  scopeKey: string
): { programId: string; cohortId: string } | null {
  const [programId, cohortId] = scopeKey.split(':');
  if (!programId || !cohortId) {
    return null;
  }

  return { programId, cohortId };
}
